import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UploadService } from 'src/app/shared/upload.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { AgendaMasivaModel } from 'src/app/models/agendaMasiva.model';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { $ } from 'protractor';
import { constants } from 'os';

@Component({
  selector: 'app-cancelar-visita-masiva',
  templateUrl: './cancelar-visita-masiva.component.html',
  styleUrls: ['./cancelar-visita-masiva.component.scss']
})
export class CancelarVisitaMasivaComponent implements OnInit {

  /**
   * Atributos CU_023
   */
  sinAdjunto: string;
  placeholderDate: string;
  placeholderSelect: string;
  fechaSeleccionada: string;
  tipoDocumentoFuncionario: string;
  numeroFuncionario: string;
  nombreArchivo: string;

  listaNombreArchivo;
  listaAgendaArchivo: AgendaMasivaModel[];

  constructor(
    private urlService: UrlService, private spiner: NgxSpinnerService
    , private uploadService: UploadService, private alertService: AlertService
    , private global: GlobalService, private modalService: NgbModal, private router: Router) {
    this.sinAdjunto = ConstantesService.INSTRUCCION_USO;
    this.placeholderDate = ConstantesService.PLACEHOLDER_DATE_PICKER;
    this.placeholderSelect = ConstantesService.PLACEHOLDER_NOMBRE_ARCHIVO;
    this.fechaSeleccionada = '';
    this.nombreArchivo = '';
    this.listaNombreArchivo = [];
    this.listaAgendaArchivo = [];

    /**
     * Documento y tipo de documento de funcionario quemados mientras se obtienen de SIA3
     */
    this.tipoDocumentoFuncionario = sessionStorage.getItem(ConstantesService.TIPO_DOC_SESSSION);
    this.numeroFuncionario = sessionStorage.getItem(ConstantesService.NUM_DOC_SESSSION);
  }

  ngOnInit(): void {
  }

  /**
   * metodo deja una fecha en formado dd/mm/yy
   * @author damunoz
   */
  agregarCerosAFecha(fecha: string): string {
    const fechaArreglo = fecha.split('/');
    if (fechaArreglo[0].length === 1) {
      fechaArreglo[0] = '0' + fechaArreglo[0];
    }
    if (fechaArreglo[1].length === 1) {
      fechaArreglo[1] = '0' + fechaArreglo[1];
    }
    if (fechaArreglo[2].length === 4) {
      fechaArreglo[2] = fechaArreglo[2].substring(2, 4);
    }
    return fechaArreglo[0] + '/' + fechaArreglo[1] + '/' + fechaArreglo[2];
  }

  handlerDatePickeR(event) {
    const dia = event.fecha.day;
    const mes = event.fecha.month;
    const ano = event.fecha.year;
    this.fechaSeleccionada = this.agregarCerosAFecha(dia + '/' + mes + '/' + ano);
    this.listaAgendaArchivo = [];
    this.listaNombreArchivo = [];
    this.obtenerNombreArchivo();
  }

  /**
   * metodo para obtener los nombres de archivos usados por el preautorizador en la fecha seleccionada
   * @author damunoz
   */
  obtenerNombreArchivo() {
    this.spiner.show();
    const serviceProvider = 'consultaNombreArchivo';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['tipoIdAutoriza', this.tipoDocumentoFuncionario]);
    queryParams.push(['numIdAutoriza', this.numeroFuncionario]);
    queryParams.push(['fechaCreacion', this.fechaSeleccionada]);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.getGenerico(url).subscribe(
      data => {
        this.listaNombreArchivo = data;
        if (this.listaNombreArchivo.length > 0) {
          this.sinAdjunto = ConstantesService.INSTRUCCION_USO;
        } else {
          this.alertService.generateAlertError(ConstantesService.MENSAJE_EXCEPCION_NO_ARCHIVOS_EN_FECHA, '');
        }
        this.spiner.hide();
      }, err => {
        this.cathException(err);
      }
    );

  }

  cathException(error: any) {
    this.spiner.hide();
    if (error && error.error) {
      this.alertService.generateAlertError(error.error.message, ' ');
    } else {
      this.alertService.generateAlertError('Se presentó un error realizando la operación', ' ');
    }

  }

  /**
   * Método encargado de obtener las agendas que fueron carcadas del archivo consultado
   * @author damunoz
   */
  public consultarAgendas(valor?: string) {
    if (valor != null) {
      this.nombreArchivo = valor;
      this.spiner.show();
      const serviceProvider = 'consultaAgendasArchivo';
      const queryParams: Array<[string, string]> = new Array<[string, string]>();
      queryParams.push(['tipoIdAutoriza', this.tipoDocumentoFuncionario]);
      queryParams.push(['numIdAutoriza', this.numeroFuncionario]);
      queryParams.push(['fechaCreacion', this.fechaSeleccionada]);
      queryParams.push(['nombreArchivo', this.nombreArchivo]);
      const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

      this.global.getGenerico(url).subscribe(
        data => {
          this.listaAgendaArchivo = data;
          this.spiner.hide();
        }, err => {
          this.listaAgendaArchivo = [];
          this.cathException(err);
        }
      );
    } else {
      this.listaAgendaArchivo = [];
    }
  }


  /**
   * metodo para regresar a consulat de visitas
   * @author fromero
   */
  regresarListaAgendas() {
    this.router.navigate(['main/']);
  }
}
